import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Azione, GenericModalData } from './generic-modal-data';

@Component({
	selector: 'lib-generic-modal',
	templateUrl: './generic-modal.component.html',
	styleUrls: ['./generic-modal.component.css']
})
export class GenericModalComponent {

	constructor(
		@Inject(MAT_DIALOG_DATA) public modalData: GenericModalData,
		public dialogRef: MatDialogRef<GenericModalComponent>) { }

	eseguiAzione(azione: Azione) {
		if (azione.effetto) {
			azione.effetto();
		}
	}

}